import { render, staticRenderFns } from "./PedidosZona.vue?vue&type=template&id=70bbe2af"
import script from "./PedidosZona.vue?vue&type=script&lang=js"
export * from "./PedidosZona.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports